import { Button } from "@/components/ui/button";

import { COPY } from "./refreshFollow";
import { useSourcingRefresh } from "./useSourcingRefresh";

export function RefreshData() {
  const { state, message, role, busy, start } = useSourcingRefresh();
  const label = state === "starting" ? COPY.starting : state === "running" ? COPY.refreshing : COPY.refresh;
  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        className="w-full sm:w-auto"
        variant="outline"
        onClick={() => void start()}
        disabled={busy}
        aria-busy={busy}
      >
        {label}
      </Button>
      {message && role ? (
        <p role={role} className={role === "alert" ? "text-sm" : "text-sm text-ks-ink"}>
          {message}
        </p>
      ) : null}
    </div>
  );
}
